import React, { useState } from 'react';
import { UsdtBalanceDisplay } from '../components/wallet/UsdtBalanceDisplay';
import { UsdtDepositForm } from '../components/wallet/UsdtDepositForm';
import { UsdtWithdrawForm } from '../components/wallet/UsdtWithdrawForm';
import { UsdtTransactionHistory } from '../components/wallet/UsdtTransactionHistory';

const TABS = [
  { id: 'deposit', label: 'ฝากเงิน' },
  { id: 'withdraw', label: 'ถอนเงิน' },
];

export function WalletPage() {
  const [activeTab, setActiveTab] = useState('deposit');

  return (
    <div className="space-y-8">
      <div className="text-center">
        <h2 className="text-2xl font-bold text-brand-red sm:text-3xl">
          กระเป๋าเงิน
        </h2>
        <p className="mt-2 text-gray-600">
          ฝาก-ถอนจากกระเป๋า Digital เข้ากระเป๋าเว็บไซต์
        </p>
      </div>

      <UsdtBalanceDisplay />

      <div className="flex justify-center gap-2">
        {TABS.map((tab) => (
          <button
            key={tab.id}
            type="button"
            onClick={() => setActiveTab(tab.id)}
            className={`rounded-xl px-5 py-2.5 text-sm font-semibold transition-colors ${
              activeTab === tab.id
                ? 'bg-brand-red text-white'
                : 'bg-white text-gray-700 ring-1 ring-gray-200 hover:bg-red-50'
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div className="mx-auto max-w-2xl">
        {activeTab === 'deposit' ? <UsdtDepositForm /> : <UsdtWithdrawForm />}
      </div>

      <UsdtTransactionHistory />
    </div>
  );
}
